import * as Yup from 'yup';

import { IFormMetadataProps, IFormProps } from '../types';

export const validationSchema = Yup.object().shape(
  {
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Email is not valid').required('Email is required'),
  },
  [['phone', 'phone']],
);

export interface IFormSchema extends IFormProps, IFormMetadataProps {
  firstName: string;
  lastName: string;
  phone?: string;
  email: string;
  smsOptIn?: boolean;
}
